var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questions-answer__box"},[_c('container',[_c('Questions',{attrs:{"ques":_vm.questions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }